/**
 * Soniox real-time dictation display helpers.
 *
 * @see https://soniox.com/docs/stt/rt/real-time-transcription
 * @see https://github.com/soniox/soniox_examples/blob/master/speech_to_text/python_sdk/soniox_sdk_realtime.py
 *
 * - Final tokens: accumulate (server sends `transcriptCumulative`)
 * - Non-final tokens: replace each event (shown as interim preview)
 * - Render: concatenate token strings only — never add, trim, or normalize spaces
 */

export function hasSttText(value) {
  if (value == null || value === "") return false;
  return /\S/.test(String(value));
}

/** Soniox cumulative sync (he/fr/ar). English/es append deltas into the sidebar. */
export function getSidebarDictationSttMode(dictationLanguage) {
  const code = String(dictationLanguage ?? "").split("-")[0].toLowerCase();
  if (code === "he" || code === "fr" || code === "ar") return "soniox";
  return "incremental";
}

/** Same as Soniox `render_tokens(final_tokens, non_final_tokens)`. */
export function renderSonioxText(preRecordingText, finalsCumulative, interimText = "") {
  return (
    String(preRecordingText ?? "") +
    String(finalsCumulative ?? "") +
    String(interimText ?? "")
  );
}

export function isCaretAtEnd(textarea) {
  if (!textarea) return true;
  const len = textarea.value.length;
  const start = textarea.selectionStart ?? 0;
  const end = textarea.selectionEnd ?? start;
  return start === end && end === len;
}

/** Free dictation: insert socket delta at caret without adding spaces. */
export function insertRawAtCaret(text, rawInsert, selectionStart, selectionEnd) {
  const current = text ?? "";
  const chunk = String(rawInsert ?? "");
  if (!hasSttText(chunk)) {
    return { text: current, caret: selectionStart ?? 0 };
  }
  const start = Math.max(0, Math.min(selectionStart ?? 0, current.length));
  const end = Math.max(start, Math.min(selectionEnd ?? start, current.length));
  const next = current.slice(0, start) + chunk + current.slice(end);
  return { text: next, caret: start + chunk.length };
}
